import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
// import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Header from '../layouts/Header';
// import Card from '@material-ui/core/Card';
// import CardActionArea from '@material-ui/core/CardActionArea';
// import CardContent from '@material-ui/core/CardContent';
// import CardMedia from '@material-ui/core/CardMedia';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import AirportShuttleIcon from '@material-ui/icons/AirportShuttle';
import AvTimerIcon from '@material-ui/icons/AvTimer';
import HeadsetMicIcon from '@material-ui/icons/HeadsetMic';
// import Box from '@material-ui/core/Box';
import Hidden from '@material-ui/core/Hidden';

export interface LoginPageViewProps {
  onSubmit: () => void;
  saveUsername: (username: string) => void;
  savePassword: (password: string) => void;
  goAdminPortal: () => void;
  goDesignerPortal: () => void;

  username: string;
  password: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      height: '100vh'
    },
    paper: {
      margin: theme.spacing(6, 4),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      boxShadow: 'none',
      backgroundColor: 'transparent'
    },
    papers: {
      margin: theme.spacing(2, 2),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      backgroundColor: 'transparent',
      boxShadow: 'none',
    },
    paperRight: {
      margin: theme.spacing(0, 5),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      backgroundColor: 'transparent',
      boxShadow: 'none',
      height: '100%',
      justifyContent: 'center'
    },
    gridHight: {
      height: '93vh'
    },
    gridCenter: {
      background: 'url(/assets/bg2.jpg)',
      backgroundRepeat: 'no-repeat',
      backgroundColor:
        theme.palette.type === 'dark' ? theme.palette.grey[900] : theme.palette.grey[50],
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      display: 'flex',
      flexDirection: 'column'
    },
    typography: {
      textAlign: 'center',
      color: '#303F9F',
      fontWeight: 500,
      marginLeft: '25%',
      marginRight: '25%',
      // boxShadow: '0 3px 5px #000',
      fontSize: '35px',
      marginTop: '5%'
    },
    typographyCard: {
      color: '#303F9F',
      textAlign: 'center'
    },
    card: {
      maxWidth: 345,
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main
    },
    font: {
      fontWeight: 500,
      fontSize: '25px',
      color: '#303F9F'
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      margin: theme.spacing(3, 1)
    },
    submit: {
      margin: theme.spacing(3, 0, 2)
    },
    cardBottom: {
      alignSelf: 'flex-end'
    },
    hlink: {
      cursor: 'pointer',
      textDecoration: 'underline',
      color: '#0000EE',
      // fontSize: '15px',
      '&:visited': {
        color: '#551A8B'
      },
      '&:link': {
        color: '#551A8B'
      }
    },
    inlineLink: {
      margin: '0',
      display: 'inline-block'
    }
  })
);

const LoginPageView: React.StatelessComponent<LoginPageViewProps> = props => {
  const classes = useStyles({});

  return (
    <div className={classes.root}>
      <Header />
      <Grid container component="main" className={classes.gridHight}>
        <CssBaseline />
        <Hidden xsDown>
          <Grid item xs="auto" sm={8} md={9} className={classes.gridCenter}>
            <Typography component="h3" variant="h3" className={classes.typography}>
              EASYDENT PROMISES
            </Typography>
            {/* <Grid container spacing={1}> */}
            <Grid container item xs={12}>
              <Grid item xs={3} className={classes.cardBottom}>
                <Paper className={classes.paper}>
                  <ThumbUpIcon style={{ fontSize: 70, color: '#303F9F' }} />
                  <Typography component="div" className={classes.typographyCard}>
                    <span className={classes.font}>High quality</span>
                    <Hidden smDown>
                      <br /> designs across a range of dental CAD products
                    </Hidden>
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={3} className={classes.cardBottom}>
                <Paper className={classes.paper} >
                  <AirportShuttleIcon style={{ fontSize: 70, color: '#303F9F' }} />
                  <Typography component="div" className={classes.typographyCard}>
                    <span className={classes.font}>Fast and reliable delivery</span>
                    <Hidden smDown>
                      <br /> with customized solutions
                    </Hidden>
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={3} className={classes.cardBottom}>
                <Paper className={classes.paper}>
                  <AvTimerIcon style={{ fontSize: 70, color: '#303F9F' }} />
                  <Typography component="div" className={classes.typographyCard}>
                    <span className={classes.font}>No need to invest</span>
                    <Hidden smDown>
                      <br /> in CAD design capex <br />and team
                    </Hidden>
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={3} className={classes.cardBottom}>
                <Paper className={classes.paper}>
                  <HeadsetMicIcon style={{ fontSize: 70, color: '#303F9F' }} />
                  <Typography component="div" className={classes.typographyCard}>
                    <span className={classes.font}>Live support</span>
                    <Hidden smDown>
                      <br /> to resolve your issues effectively and quickly
                    </Hidden>
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </Hidden>
        <Grid item xs={12} sm={4} md={3} component={Paper} elevation={6} square>
          <div className={classes.paperRight}>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign In
            </Typography>
            <form className={classes.form} noValidate onSubmit={props.onSubmit}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="userName"
                label="Username"
                name="userName"
                autoComplete="userName"
                autoFocus
                onChange={event => props.saveUsername(event.target.value)}
                value={props.username}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="passWord"
                label="Password"
                type="passWord"
                autoComplete="current-password"
                onChange={event => props.savePassword(event.target.value)}
                onKeyPress={event => {
                  if (event.key === 'Enter') {
                    props.onSubmit();
                  }
                }
                }
                value={props.password}
              />
              <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="Remember me"
              />
              <Typography variant="subtitle1" gutterBottom>
                By signing up, you agree to the <p className={classes.inlineLink}><Link to={'/termsandconditions'} >Terms & Conditions </Link>
                  and <Link to={'/privacypolicy'} >Privacy Policy</Link></p>
              </Typography>
              <Button
                type="button"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                style={{
                  background:
                    '-webkit-linear-gradient(to right, #0083B0, #00B4DB)'
                }}
                onClick={props.onSubmit}
              >
                Sign In
              </Button>
              <Grid container>
                <Grid item xs>
                  <Link to={'/forgotPassword'}>Forgot password?</Link>
                </Grid>
                <Hidden smUp>
                  <Grid item>
                    <Link to={'/signup'}>Sign Up</Link>
                  </Grid>
                </Hidden>
              </Grid>
              <Grid container>
                <Grid item xs>
                  <a onClick={props.goDesignerPortal} className={classes.hlink}>Designer Login</a>
                </Grid>
                <Hidden smUp>
                  <Grid item>
                    <Link to={'/contact'}>Contact Us</Link>
                  </Grid>
                </Hidden>
                <Grid item xs={12}>
                  <a onClick={props.goAdminPortal} className={classes.hlink}>Admin Login</a>
                </Grid>
              </Grid>
            </form>
          </div>
        </Grid>
      </Grid>
    </div >
  );
};

export default LoginPageView;



// WEBPACK FOOTER //
// ./src/components/layouts/LoginPageView.tsx